/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * reel: a vertical video. carousel: slides, in order. other: anything else.
 */
export enum SocialContentKind {
  reel = 'reel',
  carousel = 'carousel',
  other = 'other'
}
